import React, { useState, useEffect, useContext, useRef } from "react";
import { Container, Row, Col, Button, ButtonGroup, ButtonToolbar, Form, Stack, Table, Spinner, Modal, Carousel } from "react-bootstrap";
import LoggedInContainer from "../../layout/LoggedInContainer";
import Selects from "../../components/Selects";
import { getMediaMeteForConsignmentID, getMediaFileUrls, deleteMediaRecord, GetUrlOfDownloadMediaRecords } from "../../api/apiAccess";
import { useNavigate } from "react-router-dom";
import { useLocation, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretLeft, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { UserContext } from "../..";
import Dummy from "../../assets/no-picture-available.png";
import { canViewVoluntaryData, formatToAEST, getDistinctFieldValues } from "../../utils/common";
import Swal from "../../utils/Swal";
import '../../css/app.scss';

const MediaDashboard = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { consignmentID } = useParams();
  const { state } = useLocation();
  const userCtx = useContext(UserContext);
  //console.log("HealthAndMortalityReport of consignment:" + consignmentID + " state:", state);

  const [loading, setIsLoading] = useState(false);
  const [isExporterOnly, setIsExporterOnly] = useState(false);
  const [reports, setReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);
  const [dayFilter, setDayFilter] = useState(null);
  const [deckFilter, setDeckFilter] = useState(null);
  const [speciesClassFilter, setSpeciesClassFilter] = useState(0);
  const [mediaCategoriesFilter, setMediaCategoriesFilter] = useState(0);
  const [mediaTypesFilter, setMediaTypesFilter] = useState(0);
  const [mediaContentsFilter, setMediaContentsFilter] = useState(0);

  const [isShowViewModel, setIsShowViewModel] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [mediaFiles, setMediaFiles] = useState({});
  const [selectedRecords, setSelectedRecords] = useState([]);

  const [isStartedDownloading, setIsStartedDownloading] = useState(false);

  const [dayNumbers, setDayNumbers] = useState([]);
  const [deckNumbers, setDeckNumbers] = useState([]);

  const [videoErrorIndexes, setVideoErrorIndexes] = useState(new Set());

  const handleVideoError = (idx) => {
    setVideoErrorIndexes(prev => new Set(prev).add(idx));
  };

  const goBack = () => {
    navigate(-1, { state: { isHistorical: location?.state?.isHistorical } });
  };

  const gotoEditMedia = async (record) => {
    navigate(`/media/edit/` + record.id, { state: { mediaMeta: record, consignmentID: consignmentID, type: isExporterOnly } });
  };


  const showViewModel = async (record) => {
    let mediaFiles = (await getMediaFileUrls(record.id)).data;

    setMediaFiles(mediaFiles);

    setIsShowViewModel(true);
    setSelectedRecord(record);
  }

  const getItems = () => {
    let image = [];
    if (mediaFiles?.photoUrls?.length > 0 || mediaFiles?.videoUrls?.length > 0) {
      for (let i = 0; i < mediaFiles.photoUrls.length; i++) {
        image.push(
          {
            img_src: mediaFiles.photoUrls[i],
          }
        )
      }

      for (let i = 0; i < mediaFiles.videoUrls.length; i++) {
        image.push(
          {
            img_src: mediaFiles.videoUrls[i].thumbnailUrl,
            video_src: mediaFiles.videoUrls[i].url,
          }
        )
      }
    }

    return image;
  }

  useEffect(() => {
    const fetchreports = async () => {
      let reports = (await getMediaMeteForConsignmentID(consignmentID)).data;

      let days = getDistinctFieldValues(reports.filter(report => report.isExporterOnly === isExporterOnly), "dayNumber");
      let decks = getDistinctFieldValues(reports.filter(report => report.isExporterOnly === isExporterOnly), "deckNumber");

      setDayNumbers([...days.map((value, index) => ({
        id: index + 1,
        name: value
      }))]);
      setDeckNumbers([...decks.map((value, index) => ({
        id: index + 1,
        name: value
      }))])

      setReports(reports);
      setIsLoading(false);
    };

    setIsLoading(true);
    fetchreports();
  }, [isExporterOnly]);

  // Filter reports when the reports or filter options change
  useEffect(() => {
    //console.log("start filtering reports");
    let lFilteredReports = [];
    if (reports) {
      lFilteredReports = reports.filter((aReport) => reportMatchesFilter(aReport));
    }
    setFilteredReports(lFilteredReports);
  }, [reports, dayFilter, deckFilter, mediaCategoriesFilter, speciesClassFilter]);

  const reportMatchesFilter = (report) => {
    let lMatch = false;
    //console.log("reportMatchesFilter: speciesFilter", report, speciesFilter);
    if (
      (report.isExporterOnly === isExporterOnly) &&
      (deckFilter === null || report.deckNumber === deckFilter) &&
      (dayFilter === null || report.dayNumber === dayFilter) &&
      (mediaCategoriesFilter === 0 || report.voyageStatusID === mediaCategoriesFilter) &&
      (mediaTypesFilter === 0 || (report.mediaType === 1 && report.photoFilesNumber > 0) || (report.mediaType === 2 && report.videoFilesNumber > 0)) &&
      (isExporterOnly === true ? (speciesClassFilter === 0 || Number(report.classID) + 10000 * Number(report.speciesID) === speciesClassFilter) : true) &&
      (isExporterOnly === false ? (mediaContentsFilter === 0 ||
        (mediaContentsFilter === 1 && report?.isMortality === true) ||
        (mediaContentsFilter === 2 && report?.isHealthTreatment === true)) : true)

    ) {
      lMatch = true;
    }

    return lMatch;
  };

  const getMediaTypeStr = (report) => {
    const videos = report.videoFilesNumber || 0;
    const photos = report.photoFilesNumber || 0;
    const lowResSuffix = report.isHighRes ? "" : " (low-res)";

    if (videos === 0 && photos === 1) {
      return `Photo${lowResSuffix}`;
    }

    if (videos === 0 && photos > 1) {
      return `${photos} photos${lowResSuffix}`;
    }

    if (videos === 1 && photos === 0) {
      return `Video${lowResSuffix}`;
    }

    if (videos > 1 && photos === 0) {
      return `${videos} videos${lowResSuffix}`;
    }

    if (videos > 0 && photos > 0) {
      return `${videos} ${videos === 1 ? "video" : "videos"} & ${photos} ${photos === 1 ? "photo" : "photos"}${lowResSuffix}`;
    }

    return ""; // optional: return empty string if no videos or photos
  };

  const deleteMedia = (record) => {
    if (record) {
      Swal.ConfirmationDialog(`Are you sure you want to delete this media? This is an irreversible action and LiveCorp cannot recover the media`, "Delete", async () => {
        await deleteMediaRecord(record?.hashID);

        setSelectedRecord(null);
        setIsShowViewModel(false);
        setReports(reports.filter((aReport) => aReport.hashID !== record.hashID));
      });
    }
  }

  const startDownloadMedia = async () => {
    if (selectedRecords.length > 0) {
      setIsStartedDownloading(true);

      try {
        let response = await GetUrlOfDownloadMediaRecords(selectedRecords);
        let url = response.data;

        if (url) {
          // Create an invisible <a> element and trigger a click
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", state?.consignment?.lncNumber + "_mediafiles.zip"); // optional: triggers "Save As" on some browsers
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          Swal.ErrorNWait("Download Failed", "Could not retrieve a valid download URL.");
        }
      } catch (error) {
        console.error("Download error:", error);
        Swal.ErrorNWait("Error", "An error occurred while downloading the media.");
      }

      setIsStartedDownloading(false);
    } else {
      Swal.WarningNWait("No Selection", "Please select at least one record to download.");
      setIsStartedDownloading(false);
    }
  };


  return (
    <LoggedInContainer>
      <Container fluid className="p-0" style={{ backgroundColor: "#F5F5F5" }}>
        <Row className="upper-panel mx-0" style={{ position: "relative" }}>
          <Col>
            <Container>
              <Row>
                <Col xs={12} style={{ marginTop: "75px" }}>
                  <Button variant="back" onClick={() => goBack()} style={{ display: "inline", position: "absolute", top: "75px" }}>
                    <FontAwesomeIcon icon={faCaretLeft} style={{ marginRight: "5px" }} />
                    Back
                  </Button>
                  <div className="text-center heading-text mb-2 mt-3" style={{ color: "#FFF", display: "inline" }}>
                    <div style={{ lineHeight: "53px", fontSize: "35px" }}>Media:LNC-{state?.consignment?.lncNumber}</div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>

        <Container className="py-4 px-5 form-container-full">
          <Row className="mb-3" xl={12}>
            <ButtonToolbar className="p-0">
              <ButtonGroup style={{ width: "inherit" }}>
                <Button
                  variant={isExporterOnly === false ? "outline-primary" : "outline-secondary"}
                  onClick={(e) => {
                    setIsExporterOnly(false);
                    setSelectedRecords([]);

                    let days = getDistinctFieldValues(reports.filter(report => report.isExporterOnly === false), "dayNumber");
                    let decks = getDistinctFieldValues(reports.filter(report => report.isExporterOnly === false), "deckNumber");

                    if (dayFilter !== null && days.indexOf(dayFilter) === -1) {
                      setDayFilter(null);
                    }

                    if (deckFilter !== null && decks.indexOf(deckFilter) === -1) {
                      setDeckFilter(null);
                    }

                  }}
                  className="field-label"
                >
                  DEPARTMENT
                </Button>
                <Button
                  variant={isExporterOnly === true ? "outline-primary" : "outline-secondary"}
                  onClick={(e) => {
                    setIsExporterOnly(true);
                    setSelectedRecords([]);

                    let days = getDistinctFieldValues(reports.filter(report => report.isExporterOnly === true), "dayNumber");
                    let decks = getDistinctFieldValues(reports.filter(report => report.isExporterOnly === true), "deckNumber");

                    if (dayFilter !== null && days.indexOf(dayFilter) === -1) {
                      setDayFilter(null);
                    }

                    if (deckFilter !== null && decks.indexOf(deckFilter) === -1) {
                      setDeckFilter(null);
                    }
                  }}
                  className="field-label"
                >
                  EXPORTER
                </Button>
              </ButtonGroup>
            </ButtonToolbar>
          </Row>
          <Row className="mb-3 gray-frame">
            <Col>
              <Stack>
                <Form.Label style={{ fontSize: "15px" }} className="darkblue field-label mb-1">
                  Filter media by
                </Form.Label>
                <Stack direction="horizontal" gap={2}>
                  <Selects.ArraySelect
                    defaultOption={{ id: 0, name: "All Days" }}
                    onChange={(id, op) => {
                      if (id !== 0)
                        setDayFilter(op.name);
                      else
                        setDayFilter(null);
                    }}
                    options={dayNumbers}
                    selected={dayFilter === null ? 0 : dayNumbers.map(d => d.name).indexOf(dayFilter) + 1}
                  />
                  <Selects.ArraySelect
                    defaultOption={{ id: 0, name: "All Decks" }}
                    onChange={(id, op) => {
                      if (id !== 0)
                        setDeckFilter(op.name);
                      else
                        setDeckFilter(null);
                    }}
                    options={deckNumbers}
                    selected={deckNumbers === null ? 0 : deckNumbers.map(d => d.name).indexOf(deckFilter) + 1}

                  />
                  <Selects.ConsignmentMediaCategoriesSelect
                    defaultOption={{ id: 0, name: "All Media Categories" }}
                    onChange={(e) => {
                      setMediaCategoriesFilter(e);
                    }
                    }
                  />
                  <Selects.ConsignmentMediaTypesSelect
                    defaultOption={{ id: 0, name: "All Media Types" }}
                    onChange={(e) => {
                      setMediaTypesFilter(e);
                    }
                    }
                  />
                  {isExporterOnly &&
                    <Selects.ConsignmentAnimalSpeciesAndClassesSelet
                      defaultOption={{ id: 0, name: "All Species/Classes" }}
                      onChange={(e) => {
                        setSpeciesClassFilter(Number(e));
                      }}
                      selected={speciesClassFilter}
                      consignmentID={consignmentID}
                    />}
                  {!isExporterOnly &&
                    <Selects.ConsignmentMediaContentsSelect
                      defaultOption={{ id: 0, name: "All Content" }}
                      onChange={(e) => {
                        setMediaContentsFilter(Number(e));
                      }}
                    />}
                </Stack>
              </Stack>
            </Col>
            <Col xs={2}>
              <Stack>
                <Button
                  className="field-label btn-primary mt-4"
                  onClick={(e) => startDownloadMedia()}
                >
                  {isStartedDownloading ? "DOWNLOADING..." : "DOWNLOAD SELECTED"}
                  {isStartedDownloading && <FontAwesomeIcon icon={faSpinner} spin className="ms-2" />}

                </Button>
              </Stack>
            </Col>
          </Row>
          <Row>
            <Col>
              <Table>
                <thead>
                  <tr>
                    <th><Form.Check
                      type={`checkbox`}
                      checked={selectedRecords.length === filteredReports.length && filteredReports.length > 0}
                      onChange={() => {
                        if (selectedRecords.length === filteredReports.length && filteredReports.length > 0) setSelectedRecords([])
                        else setSelectedRecords(filteredReports.map((r) => r.hashID))
                      }}
                      className="field-label secondary-grey"
                    /></th>
                    <th className="darkblue field-label mb-1 text-center">Reporting Day</th>
                    <th className="darkblue field-label mb-1 text-center">Deck</th>
                    <th className="darkblue field-label mb-1 text-center">Pen</th>
                    <th className="darkblue field-label mb-1 text-center">Media Category</th>
                    <th className="darkblue field-label mb-1 text-center">Media Type</th>
                    {!isExporterOnly && <th className="darkblue field-label mb-1 text-center">Species/Class</th>}
                    {isExporterOnly && <th className="darkblue field-label mb-1 text-center">Exporter Line</th>}
                    {isExporterOnly && <th className="darkblue field-label mb-1 text-center">Is Mortality or<br /> Post-Mortem?</th>}
                    {isExporterOnly && <th className="darkblue field-label mb-1 text-center">  Is Health<br /> Treatment? </th>}
                    <th className="darkblue field-label mb-1 text-center">Comments</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody className="field-label">
                  {filteredReports &&
                    filteredReports.map(
                      (record, index) =>
                        record && (
                          <tr key={"media_report-" + index}>
                            <td className="align-middle text-center lines">
                              <Form.Check
                                type={`checkbox`}
                                checked={selectedRecords.includes(record.hashID)}
                                onChange={() => {
                                  if (!selectedRecords.includes(record.hashID)) setSelectedRecords([...selectedRecords, record.hashID])
                                  else setSelectedRecords(selectedRecords.filter((r) => r !== record.hashID))
                                }}
                                className="field-label secondary-grey"
                              />
                            </td>
                            <td className="align-middle text-center" >
                              {record.dayNumber}
                            </td>
                            <td className="align-middle text-center">
                              {record.deckNumber}
                            </td>
                            <td className="align-middle text-center" >
                              {record.penName}
                            </td>
                            <td className="align-middle text-center" >
                              {record.voyageStatus}
                            </td>
                            <td className="align-middle text-center" >
                              {getMediaTypeStr(record)}
                            </td>
                            {!isExporterOnly &&
                              <td className="align-middle text-center" >
                                {record.speciesName} - {record.className}
                              </td>
                            }
                            {isExporterOnly &&
                              <td className="align-middle text-center" >
                                {record.exporterLine}
                              </td>
                            }
                            {isExporterOnly &&
                              <td className="align-middle text-center" >
                                {record.isMortality ? "Yes" : "No"}
                              </td>
                            }{isExporterOnly &&
                              <td className="align-middle text-center" >
                                {record.isHealthTreatment ? "Yes" : "No"}
                              </td>
                            }

                            <td className="align-middle text-center" >
                              {record.comment.length > 0 ? "Yes" : "No"}
                            </td>

                            <td className="align-middle text-center" key={"health-record-btns" + index}>
                              <Button className="field-label" variant="outline-secondary" onClick={(e) => showViewModel(record)}>
                                View
                              </Button>
                            </td>
                          </tr>
                        )
                    )}
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row>
            <Col>
              {loading === true ? (
                <Row>
                  <Col>
                    <div className="text-center pt-5">
                      <Spinner className="mx-auto" />
                      <div className="mx-auto">Loading data...</div>
                    </div>
                  </Col>
                </Row>
              ) : null}
            </Col>
          </Row>
        </Container>
      </Container>

      <Modal
        show={isShowViewModel}
        onHide={() => {
          setIsShowViewModel(false);
          setSelectedRecord(null);
          setMediaFiles({});
        }}
        dialogClassName="media-view-modal"
      >
        <Modal.Body>
          <Carousel>
            {mediaFiles && getItems().map((item, idx) => (
              <Carousel.Item key={idx}>
                <div style={{ display: "flex", justifyContent: "center" }}>

                  {item.video_src === undefined || videoErrorIndexes.has(idx) ? (
                    // Show image either if no video or video errored
                    <img
                      className="d-block"
                      src={item.img_src || Dummy}
                      alt={`Slide ${idx + 1}`}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = Dummy;
                      }}
                      style={{ maxHeight: "100vh", width: "auto", objectFit: "contain", }}
                    />
                  ) : (
                    // Show video only if no error
                    <video
                      className="d-block"
                      controls
                      autoPlay
                      alt={`Slide ${idx + 1}`}
                      onError={() => handleVideoError(idx)}
                      style={{ maxHeight: "75vh", width: "auto" }}
                    >
                      <source src={item.video_src} type="video/mp4" />
                    </video>
                  )}
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </Modal.Body>
        <Container style={{ padding: "0px !important" }}>
          <Row className="mt-0">
            <Col className="field-label" xs={3}>
              {formatToAEST(selectedRecord?.captureDateUTC, selectedRecord?.timeZone)}
            </Col>
            <Col className="field-label" xs={1}>
              Deck {selectedRecord?.deckNumber}
            </Col>
            <Col className="field-label" xs={1} >
              Pen {selectedRecord?.penName}
            </Col>
            {
              !isExporterOnly &&
              <Col className="field-label" xs={2} >
                No head in Pen: {selectedRecord?.numberOfHead}
              </Col>
            }
            <Col className="field-label" xs={2}>
              {selectedRecord?.speciesName} - {selectedRecord?.className}
            </Col>
            <Col className="field-label" xs={2}>
              Category: {selectedRecord?.voyageStatus}
            </Col>
          </Row>
          <Row className="mt-2">

            {
              isExporterOnly &&
              <>
                <Col className="field-label" xs={3}>
                  Exporter Line: {selectedRecord?.exporterLine ? selectedRecord?.exporterLine : "N/A"}
                </Col>
                <Col className="field-label" xs={3}>
                  Animal Identification Details: {selectedRecord?.animalIdentificationDetails ? selectedRecord?.animalIdentificationDetails : "N/A"}
                </Col>
                <Col className="field-label" xs={3} >
                  Is Mortality or Post-Mortem? {selectedRecord?.isMortality ? "Yes" : "No"}
                </Col>
                <Col className="field-label" xs={3}>
                  Is Health Treatment? {selectedRecord?.isHealthTreatment ? "Yes" : "No"}
                </Col>
              </>
            }
          </Row>
          <Row className="mt-2">
            {
              isExporterOnly &&
              <Col className="field-label" xs={8} style={{overflowY:"auto", maxHeight:"49px"}}>
                Comment: <br /> {selectedRecord?.comment ? selectedRecord?.comment : "N/A"}
              </Col>
            }
            {
              !isExporterOnly &&
              <Col className="field-label" xs={8} style={{overflowY:"auto", maxHeight:"49px"}}>
                {selectedRecord?.comment}
              </Col>
            }
            <Col xs={4} className="text-end mb-2">
              <Button className="field-label me-2" variant="outline-secondary" onClick={(e) => gotoEditMedia(selectedRecord)}>
                EDIT DETAILS
              </Button>
              <Button className="field-label me-2" variant="outline-secondary" onClick={(e) => deleteMedia(selectedRecord)}>
                DELETE RECORD
              </Button>
              <Button className="field-label" variant="outline-secondary" onClick={(e) => setIsShowViewModel(false)}>
                CLOSE
              </Button>
            </Col>
          </Row>
        </Container>
      </Modal>
    </LoggedInContainer>
  );
};

export default MediaDashboard;
